import axios from 'axios';
import { apiBaseUrl } from "../../../../utils/URLUtils";
import { loginToken, logOut } from '../../../../utils/LocalStorageUtils'
import { handleError } from '../../../../utils/ErrorUtils'
import {toast} from "react-toastify";
import {AppSource, ConfigToastAlert} from "../../../../Config";

function _success(success)
{
  return { type: 'FETCH_USER_SUCCESS', success };
}
function _error(error)
{
  return { type: 'FETCH_USER_ERROR', error };
}
function _processing(processing)
{
  return { type: 'FETCH_USER_PROCESSING', processing };
}

function getUserDetails()
{
  return ( dispatch ) =>
  {
    dispatch(_processing(true));
    dispatch(_success(null));
    dispatch(_error(null));

    axios({
      url: apiBaseUrl(`auth/v1/user/details`),
      method: "get",
      dataType: 'json',
      headers: {
        'Authorization': 'Bearer ' + loginToken(),
        'x-app-source': AppSource.appSource
      }
    })
      .then(function(res){
        let role = res.data.data.roles[0].name;
        if(role === 'customer' || role === 'reservation-operator' || role === 'branch-operator' || role === 'admin' || role === 'super-admin') {
          toast.error(`Requested User Role not found`, ConfigToastAlert);
          setTimeout( () => {
            logOut();
            window.location.href="/login";
          },3000)

        }else{
          dispatch(_success(res.data.data));
          dispatch(_processing( false ));
        }
      }).catch(function( error ){
        // console.log(` <| error |> `, {error} )
        if ( error && error.response && error.response.status === 401  ) {
          logOut()
          window.location.href="/login";
        } else{
          logOut()
          handleError( error );
          dispatch(_error(error));
          dispatch(_processing(false));
        }
      });
  }
}
export default getUserDetails;